import { render, staticRenderFns } from "./sms.vue?vue&type=template&id=0ff2ab25&scoped=true"
import script from "./sms.vue?vue&type=script&lang=ts"
export * from "./sms.vue?vue&type=script&lang=ts"
import style0 from "./sms.vue?vue&type=style&index=0&id=0ff2ab25&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff2ab25",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/frontend_page_elephant/frontend_page_elephant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ff2ab25')) {
      api.createRecord('0ff2ab25', component.options)
    } else {
      api.reload('0ff2ab25', component.options)
    }
    module.hot.accept("./sms.vue?vue&type=template&id=0ff2ab25&scoped=true", function () {
      api.rerender('0ff2ab25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/agent/sms.vue"
export default component.exports